import React, { useEffect, useState } from 'react';
import { __ } from '@wordpress/i18n';
import { isEmpty } from 'ramda';

import { useStoreValue } from '../../store';
import CommunicationService from '../../service/communication-service';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';

const CommunicationsBeneficiary = () => {
    const chosenCompanyId = useStoreValue('chosenCompanyId');
    const [voci, setVoci] = useState([]);
    const [caricamento, setCaricamento] = useState(false);
    const [apertaVisibile, setApertaVisibile] = useState(false);
    const [aperta, setAperta] = useState(null);

    useEffect(() => {
        if (!chosenCompanyId || chosenCompanyId === 0) return;
        setCaricamento(true);
        CommunicationService.getInbox(chosenCompanyId, (resp) => {
            setCaricamento(false);
            if (resp.status === 'SUCCESS') setVoci(resp.data || []);
        }, () => setCaricamento(false));
    }, [chosenCompanyId]);

    const dataTemplate = (riga) => riga.data
        ? new Date(riga.data).toLocaleString('it-IT', {
            day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
        })
        : '-';

    const tipoTemplate = (riga) => <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
        <Tag value={riga.tipo === 'MAIL' ? __('Email', 'htr') : __('Messaggio', 'htr')}
             severity={riga.tipo === 'MAIL' ? 'info' : 'secondary'}/>
        <Tag value={riga.direzione === 'INVIATA' ? __('Inviata', 'htr') : __('Ricevuta', 'htr')}
             severity={riga.direzione === 'INVIATA' ? 'success' : 'warning'}/>
    </div>;

    const azioniTemplate = (riga) => <Button type="button" outlined size="small" icon="pi pi-envelope"
                                             label={__('Apri', 'htr')}
                                             onClick={() => { setAperta(riga); setApertaVisibile(true); }}/>;

    return (
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Comunicazioni', 'htr')}</h1>
            </div>
            <div className="appPage__spacer"></div>

            {!chosenCompanyId || chosenCompanyId === 0
                ? <div className="appPageSection__message warning">
                    <i className="pi pi-exclamation-triangle"></i>
                    <span>{__('Nessuna azienda selezionata.', 'htr')}</span>
                </div>
                : <div className="appPageSection">
                    <DataTable value={voci} loading={caricamento} dataKey="id"
                               paginator rows={15}
                               emptyMessage={__('Nessuna comunicazione.', 'htr')}>
                        <Column header={__('Data', 'htr')} body={dataTemplate} style={{ width: '170px' }}/>
                        <Column header={__('Tipo', 'htr')} body={tipoTemplate} style={{ width: '220px' }}/>
                        <Column field="oggetto" header={__('Oggetto', 'htr')}/>
                        <Column header={__('Azioni', 'htr')} body={azioniTemplate} style={{ width: '120px' }}/>
                    </DataTable>
                </div>}

            <Dialog visible={apertaVisibile} modal maximizable
                    style={{ maxWidth: '820px', width: '100%' }}
                    header={aperta && aperta.oggetto ? aperta.oggetto : __('Comunicazione', 'htr')}
                    onHide={() => setApertaVisibile(false)}>
                {aperta
                    ? <div>
                        <p style={{ color: '#5a6b7f', fontSize: '0.9rem' }}>{dataTemplate(aperta)}</p>
                        <div style={{
                            border: '1px solid #e3e8ef', borderRadius: '6px',
                            padding: '12px', maxHeight: '60vh', overflowY: 'auto', background: '#fff'
                        }} dangerouslySetInnerHTML={{ __html: aperta.testo || '' }}/>
                    </div>
                    : null}
            </Dialog>
        </div>
    );
};

export default CommunicationsBeneficiary;
